// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h2 {
    font-size: 1.5rem;
    font-weight: bold;
}

p {
    font-size: 1rem;
    line-height: 1.5em;
}

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.browser-modal_modal-overlay_uZSJT {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 510;
    background-color: var(--ui-modal-overlay);
}

.browser-modal_modal-content_giqV0 {
    margin: 100px auto;
    outline: none;
    border: .25rem solid var(--ui-white-transparent);
    padding: 0;
    border-radius: 0.5rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    width: 500px;

    color: var(--text-primary);
    overflow: hidden;
}

.browser-modal_illustration_AdBeu {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    background-color: var(--control-primary);
}

[dir="rtl"] .browser-modal_illustration_AdBeu {
    transform: scaleX(-1);
}

.browser-modal_illustration_AdBeu img {
    height: 80%;
    width: auto;
}

.browser-modal_body_Pc1Za {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.browser-modal_title_vrDDn {
    text-align: center;
}

.browser-modal_desktop-settings-outer_zUGbL {
    display: flex;
    justify-content: center;
}

.browser-modal_desktop-settings-inner_K6ddc {
    font: inherit;
    font-weight: bold;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    background-color: var(--looks-secondary);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/browser-modal/browser-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,2DAA2D;AAC/D;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gDAAgD;IAChD,UAAU;IACV,qBAAqB;IACrB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,YAAY;;IAEZ,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,wCAAwC;IACxC,YAAY;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\nbody {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\nh2 {\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\np {\n    font-size: 1rem;\n    line-height: 1.5em;\n}\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 510;\n    background-color: var(--ui-modal-overlay);\n}\n\n.modal-content {\n    margin: 100px auto;\n    outline: none;\n    border: .25rem solid var(--ui-white-transparent);\n    padding: 0;\n    border-radius: 0.5rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    width: 500px;\n\n    color: var(--text-primary);\n    overflow: hidden;\n}\n\n.illustration {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100px;\n    background-color: var(--control-primary);\n}\n\n[dir=\"rtl\"] .illustration {\n    transform: scaleX(-1);\n}\n\n.illustration img {\n    height: 80%;\n    width: auto;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.title {\n    text-align: center;\n}\n\n.desktop-settings-outer {\n    display: flex;\n    justify-content: center;\n}\n\n.desktop-settings-inner {\n    font: inherit;\n    font-weight: bold;\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    background-color: var(--looks-secondary);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `browser-modal_modal-overlay_uZSJT`;
export { _1 as "modal-overlay" };
export var modalOverlay = `browser-modal_modal-overlay_uZSJT`;
var _2 = `browser-modal_modal-content_giqV0`;
export { _2 as "modal-content" };
export var modalContent = `browser-modal_modal-content_giqV0`;
export var illustration = `browser-modal_illustration_AdBeu`;
export var body = `browser-modal_body_Pc1Za`;
export var title = `browser-modal_title_vrDDn`;
var _3 = `browser-modal_desktop-settings-outer_zUGbL`;
export { _3 as "desktop-settings-outer" };
export var desktopSettingsOuter = `browser-modal_desktop-settings-outer_zUGbL`;
var _4 = `browser-modal_desktop-settings-inner_K6ddc`;
export { _4 as "desktop-settings-inner" };
export var desktopSettingsInner = `browser-modal_desktop-settings-inner_K6ddc`;
export default ___CSS_LOADER_EXPORT___;
